export enum socketActionType {
  EXPORT_TO_QUICKBOOKS = "ExportInvoice",
  DOWNLOAD_INVOICE = "DownloadInvoiceZip",
  DOWNLOAD_ALL_UNPAID = "DownloadBatches",
  SYNC_QUICKBOOKS = "SyncQuickbooks",
  SYNC_FOR_CUSTOMER_DATABASE = "SyncQuickbooksInCxDB",
  DOWNLOAD_SINGLE_BATCH = "DownloadSingleBatch",
  SYNC_FOR_QUARRY_DATABASE = "SyncQuickbooksInQuarryDB",
  GENERATE_BATCH_DOCUMENTS = "GenerateDocuments",
  RECALL_INVOICE = "RecallInvoice",
  DOWNLOAD_ORIGINAL = "DownloadOriginal",
}

export enum socketStatus {
  SUCCESS = "success",
  CLOSED = "closed",
  FAILED = "error",
  IDLE = "idle",
  CONNECTING = "connecting",
}
